module.exports = __webpack_public_path__ + "img/kramarz.3d887d60.jpg";